// Форма league_settings: общая для вкладки "Настройки сезона" и для создания сезона.

export const RATE_RATIOS = [
  { value: 20, label: '20', hint: 'слабый' },
  { value: 30, label: '30', hint: 'ниже среднего' },
  { value: 40, label: '40', hint: 'средний' },
  { value: 50, label: '50', hint: 'выше среднего' },
  { value: 60, label: '60', hint: 'сильный' },
];

export const emptySettingsForm = () => ({
  league_type: 1,
  group_stages_amount: '',
  application_id: '',
  application_active: false,
  rate_ratio: null,
  penalty_enabled: false,
  penalty_draw_score: '2',
});

export const settingsFormFrom = (settings) => ({
  league_type: Number(settings.league_type) === 2 ? 2 : 1,
  group_stages_amount: settings.group_stages_amount !== null && settings.group_stages_amount !== undefined
    ? String(settings.group_stages_amount) : '',
  application_id: settings.application_id !== null && settings.application_id !== undefined
    ? String(settings.application_id) : '',
  application_active: Number(settings.application_active) === 1,
  rate_ratio: settings.rate_ratio !== null && settings.rate_ratio !== undefined
    ? Number(settings.rate_ratio) : null,
  penalty_enabled: settings.penalty_draw_score !== null && settings.penalty_draw_score !== undefined,
  penalty_draw_score: settings.penalty_draw_score !== null && settings.penalty_draw_score !== undefined
    ? String(settings.penalty_draw_score) : '2',
});

export const settingsFormToPatch = (form) => ({
  league_type: form.league_type,
  group_stages_amount: form.league_type === 2 ? parseInt(form.group_stages_amount, 10) : null,
  application_id: form.application_id === '' ? null : parseInt(form.application_id, 10),
  application_active: form.application_active ? 1 : 0,
  rate_ratio: form.rate_ratio,
  penalty_draw_score: form.penalty_enabled ? parseInt(form.penalty_draw_score, 10) : null,
});

// Что мешает сохранить настройки; пустая строка — всё заполнено.
// Заявка обязательна: без league_settings.application_id капитаны не могут
// заявлять игроков на сезон
export const settingsFormError = (form) => {
  if (!form) return 'Настройки сезона не загружены.';
  if (form.league_type === 2) {
    const groups = parseInt(form.group_stages_amount, 10);
    if (isNaN(groups) || groups <= 0) return 'Укажите, сколько туров идёт в группу.';
  }
  if (form.penalty_enabled && !(parseInt(form.penalty_draw_score, 10) > 0)) {
    return 'Укажите очки за победу в серии пенальти.';
  }
  if (!(parseInt(form.application_id, 10) > 0)) return 'Выберите заявку сезона.';
  return '';
};

export const isSettingsFormValid = (form) => settingsFormError(form) === '';
